<template>
  <div class="relative overflow-hidden whitespace-nowrap">
    <div class="flex items-center justify-between h-10 px-4 bg-white border border-b-gray-300 rounded-lg cursor-pointer"
      @click="openSearch">
      <div class="inline-flex items-center gap-2">
        <NuxtImg src="/v2/icons/SearchBar-icon.png" alt="Search Icon" class="w-4 h-4" />
        <div class="flex gap-1">
          <p class="flex self-center text-[#828282]">{{ isSubCategoryPage || isFilterV2 ? 'Search for Products' :
            'Search' }}</p>
          <V2ListAnimateComponent v-if="!isSubCategoryPage && !isFilterV2" class="text-[#828282]"
            :items="placeholder" />
        </div>
      </div>
    </div>
  </div>
  <V2ResponsivePanel side="bottom" v-model="computedSearchModalOpened">
    <div class="bg-inherit">
      <V2SearchModalComponent :filters="filters" @openlocation="handleOpenLocation" @close="closeSearch"
        @navigate="handleNavigate" />
    </div>
  </V2ResponsivePanel>
</template>

<script setup>
import { nextTick } from "vue";

const props = defineProps({
  placeholder: { type: Array, default: [] },
  filters: { type: Object, default: {} }
});

const openedFromSearch = ref(false);
const isSearchModalOpened = ref(false);
const route = useRoute();
const router = useRouter();
const isSubCategoryPage = computed(() => route.path.includes('search-v2'));
const isFilterV2 = computed(() => route.path.includes('/filter/v2'));
const { openLocationPicker, openLocationUpdate, isLocationPickerOpen, isLocationUpdateOpen } = useLocationPicker()
const { isAuthenticated } = storeToRefs(useAuth());

const computedSearchModalOpened = computed({
  get() {
    return isSearchModalOpened.value
  },
  set(val) {
    isSearchModalOpened.value = val
  }
})
const openSearch = async () => {
  if (location.hash !== '#search') {
    history.replaceState(null, '', '#search');
  }
  isSearchModalOpened.value = true

  await nextTick()

  requestAnimationFrame(() => {
    const input = document.querySelector('input[type="text"]')
    if (input) {
      input.focus()
    }
  })
}

const handleOpenLocation = async () => {
  openedFromSearch.value = true;
  // 1. close only search
  closeSearch();

  // 2. wait for DOM + state update
  await nextTick();

  // 3. extra safety: ensure search is really closed
  setTimeout(() => {
    if (isAuthenticated.value) {
      openLocationUpdate();
    } else {
      openLocationPicker();
    }
  }, 50);
};

const closeSearch = () => {
  if (location.hash === '#search') {
    history.replaceState(null, '', location.pathname + location.search); 
    isSearchModalOpened.value = false;
  } else {
    isSearchModalOpened.value = false;
  }
};

// watch(isSearchModalOpened, (open) => {
//   if (!open && location.hash === '#search') {
//     history.back();
//   }
// });
const handlePop = () => {
  if (location.hash !== '#search') {
    isSearchModalOpened.value = false;
  }
};

const clearHash = () => {
  if (location.hash === '#search') {
    history.replaceState(null, '', location.pathname + location.search);
  }
};

const handleNavigate = (routeData) => {
  clearHash();
  router.push(routeData);
};

onMounted(() => {
  window.addEventListener("popstate", handlePop);
});

onUnmounted(() => {
  window.removeEventListener("popstate", handlePop);
});

let prevLocationState = false;

watch(
  [isLocationPickerOpen, isLocationUpdateOpen],
  ([pickerOpen, updateOpen]) => {
    const isOpen = pickerOpen || updateOpen;
    if (prevLocationState === true && isOpen === false &&
      openedFromSearch.value ) {
      requestAnimationFrame(() => {
        openSearch();
      });
      openedFromSearch.value = false;
    }
    prevLocationState = isOpen;
  }
);

</script>
